// eslint-disable-next-line import/named
import { DOCUMENT_STEP_ROUTER_NUMBER } from '@/config';
import persons from './persons';
import enums from './enums';

export default {
  mixins: [persons, enums],
  computed: {
    AttachmentTypeEnum() { return this.$kotlin.attachments.AttachmentTypeEnum; },
    routes() {
      const isChild = this.childrenWithIndexes.length > 0;
      const isFamily = this.model.insuranceType === this.enums.InsuranceTypeEnum.FAMILY;
      return this.$router.options.routes
        .filter((route) => route.meta?.label)
        .map((route) => route.meta)
        // Show step logic
        .map((meta) => {
          const { routeStepType } = meta;
          const childStepVisible = isChild && (routeStepType === 'COMMON' || routeStepType === 'CHILD');
          const familyStepVisible = isFamily && (routeStepType === 'COMMON' || routeStepType === 'ADULT');
          const adultStepVisible = !isChild && !isFamily && (routeStepType === 'COMMON' || routeStepType === 'ADULT');
          const visible = (childStepVisible || familyStepVisible || adultStepVisible)
            && !(!this.personsWithRequiredAttachments.length && meta.step === DOCUMENT_STEP_ROUTER_NUMBER);
          return {
            ...meta,
            visible,
          };
        });
    },
  },
  methods: {
    getNearestPreviousAvailableStep() {
      let { currentPersonStepIndex } = this.model;
      let { currentPersonIndex } = this.model;
      let nextBackStep;

      // ak som na prvej osobe prvom kroku
      if (currentPersonIndex === 0 && currentPersonStepIndex - 1 < 0) {
        this.model.currentPersonStepIndex -= 1;
        nextBackStep = 1;
        return nextBackStep;
      }

      // vytiahnem si visitedSteps aktualnej osoby
      let visitedSteps = this.model.insuredPersons.array_hd7ov6$_0[currentPersonIndex].visitedSteps.array_hd7ov6$_0;
      // ak sa nachadzam na konci aktualnej osoby
      if (currentPersonIndex > 0 && currentPersonStepIndex - 1 < 0) {
        // dekrementujem index aktualnej osoby na predchadzajucu
        this.model.currentPersonIndex -= 1;
        // vytiahnem si posledny index na jej posledny step vo visitedSptes
        this.model.currentPersonStepIndex = this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.length - 1;
        currentPersonStepIndex = this.model.currentPersonStepIndex;
        currentPersonIndex = this.model.currentPersonIndex;
        // nacitam si visitedSteps tejto osoby
        visitedSteps = this.model.insuredPersons.array_hd7ov6$_0[currentPersonIndex].visitedSteps.array_hd7ov6$_0;
        // vytiahnem si posledny step
        nextBackStep = visitedSteps[currentPersonStepIndex];
      } else {
        // vytiahnem si co ma byt dalsi step smerom dozadu
        nextBackStep = visitedSteps[currentPersonStepIndex - 1];
      }

      // ak je to 9 (pridanie dalsej osoby, ten preskakujem lebo na ten sa mam dostat len smerom dopredu po kliku na button, nie v spatnom flowe (aspon tak tomu rozumiem ja)
      if (nextBackStep === 9) {
        nextBackStep = visitedSteps[currentPersonStepIndex - 2];
        this.model.currentPersonStepIndex -= 1;
      }
      this.model.currentPersonStepIndex -= 1;
      return nextBackStep;
    },
    getNearestNextAvailableStep() {
      const currentStep = this.$route.meta?.step;
      const nextSteps = this.routes
        .filter((route) => route.visible && typeof route.step === 'number') // Filter only available routes
        .map((route) => route.step) // Map routes and return their steps
        .filter((step) => step > currentStep); // Returns only next steps
      return Math.min(...nextSteps);
    },
  },
};
